import { mutedSpeechDetectionStore } from '../store/store';

export const selectIsUserSpeakWhileMuted = (): boolean => mutedSpeechDetectionStore.isUserSpeakWhileMuted;
